module.exports = __webpack_public_path__ + "static/media/sonicbathtub1.f7ecd31f.jpg";